<div class="card">
    <p-steps [model]="steps" [activeIndex]="activeIndex"></p-steps>
</div>
<div class="submit-deal-container">
    <p-card *ngIf="firstStep">
        <ng-template pTemplate="title">
            {{'link_to_deal' | translate}}
        </ng-template>
        <ng-template pTemplate="content">
            <div class="p-fluid field">
                            <span class="p-float-label p-input-icon-right">
            <input class="inputfield w-full" id="url" type="text"
                   [(ngModel)]="dealUrl"
                   pInputText
                   (keyup.enter)="prepareNewDeal(dealUrl)"
                   required>
            <label for="url">{{'url' | translate}}</label>
        </span>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <div class="grid grid-nogutter justify-content-end">
                <button pButton label="{{'go_btn' | translate}}"
                        type="button"
                        class="p-button-raised p-button-dlnd flex-grow-1 md:flex-grow-0"
                        (click)="prepareNewDeal(dealUrl)"
                        [loading]="loadingDetails"></button>
            </div>
        </ng-template>
    </p-card>
    <p-card *ngIf="secondStep">
        <ng-template pTemplate="title">
            {{'add_deal_heading'| translate}}
        </ng-template>
        <ng-template pTemplate="content">
            <div class="formgrid grid">
                <div class="field col submit-image-field">
                    <h5>{{'deal_image' | translate}}</h5>
                    <ngx-dropzone [multiple]="false" (change)="onSelect($event)">
                        <p-image [src]="deal.imageURL" alt="Deal image" width="250"
                                 *ngIf="deal.imageURL !== undefined &&
                                    deal.imageURL !== null &&
                                    deal.imageURL !== ''"></p-image>
                        <ngx-dropzone-image-preview [style]="{'padding':'5%!important'}" [file]="selectedFile"
                                                    *ngIf="deal.imageURL === undefined ||
                                                           deal.imageURL === null ||
                                                           deal.imageURL === ''">
                        </ngx-dropzone-image-preview>
                    </ngx-dropzone>
                </div>
                <div class="field col">
                    <div class="field">
                        <h5>{{'deal_title' | translate}}</h5>
                        <input id="title" 
                               class="inputfield w-full"
                               type="text"
                               [(ngModel)]="deal.title"
                               pInputText
                               [required]="true">
                    </div>
                        <div class="field">
                            <h5>{{'deal_type' | translate}}</h5>
                            <p-dropdown [options]="offersType"
                                        [(ngModel)]="deal.promotionType"
                                        optionLabel="label"
                                        optionValue="value"
                                        class="w-full"
                                        styleClass="w-full"
                                        required="true">
                            </p-dropdown>
                        </div>
                        <div class="field">
                            <h5>{{'category' |  translate}}</h5>
                            <p-dropdown [options]="categories"
                                        [(ngModel)]="deal.category"
                                        optionLabel="category_name"
                                        optionValue="category_id"
                                        [showClear]="true"
                                        required="true"
                                        class="w-full"
                                        styleClass="w-full"
                                        placeholder="{{'choose_category' | translate}}"></p-dropdown>
                        </div>
                </div>
            </div>
            <div class="formgrid grid">
                <div class="filed col">
                    <h5>{{'store' | translate}}</h5>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="text-field-icon icon-store"></i></span>
                        <input type="text"
                               [(ngModel)]="deal.store"
                               pInputText>
                    </div>
                </div>
                <div class="filed col">
                    <h5>{{'promo_code' | translate}}</h5>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-ticket"></i></span>
                        <input type="text"
                               [(ngModel)]="deal.promoCode"
                               pInputText>
                    </div>
                </div>
                <div class="filed col">
                    <h5>{{'expiration' | translate}}</h5>
                    <div class="p-inputgroup inputfield w-full">
                        <span class="p-inputgroup-addon"><i class="pi pi-calendar"></i></span>
                        <p-calendar type="text"
                                    [(ngModel)]="deal.expire"
                                    [readonlyInput]="true"
                                    styleClass="w-full"
                                    pInputText>
                        </p-calendar>
                    </div>
                </div>
            </div>
            <hr>
            <h4>{{'cost' | translate}}</h4>
            <div class="formgrid grid">
                <div class="field col"
                     [ngClass]="{'col-12 md:col-6' : ((deal.priceDeal == null || deal.priceDeal == undefined) &&
                                                (deal.priceOld == null || deal.priceOld == undefined))}">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">{{'currency_unit' | translate}}</span>
                        <span class="p-float-label ">
                            <p-inputNumber mode="decimal" locale="{{'LOCALE' | translate}}"
                                           [(ngModel)]="deal.priceDeal"
                                           [minFractionDigits]="2"
                                           [maxFractionDigits]="2"
                                           pInputText ></p-inputNumber>
                        <label>{{'price' | translate}}</label>
                        </span>
                    </div>
                </div>
                <div class="field col"
                     [ngClass]="{'col-12 md:col-6' : ((deal.priceDeal == null || deal.priceDeal == undefined) &&
                                                (deal.priceOld == null || deal.priceOld == undefined))}">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">{{'currency_unit' | translate}}</span>
                        <span class="p-float-label ">
                            <p-inputNumber mode="decimal" locale="{{'LOCALE' | translate}}"
                                           [(ngModel)]="deal.priceOld"
                                           [minFractionDigits]="2"
                                           [maxFractionDigits]="2"
                                           pInputText ></p-inputNumber>
                            <label>{{'list_price' | translate}}</label>
                        </span>
                    </div>
                </div>
                <div class="field col"
                     [ngClass]="{'col-12 md:col-6' : ((deal.priceDeal == null || deal.priceDeal == undefined) &&
                                                (deal.priceOld == null || deal.priceOld == undefined))}">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">{{'currency_unit' | translate}}</span>
                        <span class="p-float-label ">
                            <p-inputNumber mode="decimal" locale="{{'LOCALE' | translate}}"
                                           [(ngModel)]="deal.shipping"
                                           [minFractionDigits]="2"
                                           [maxFractionDigits]="2"
                                           pInputText ></p-inputNumber>
                            <label>{{'shipping_cost' | translate}}</label>
                        </span>
                    </div>
                </div>
                <div class="field col-12 md:col-6" *ngIf="((deal.priceDeal == null || deal.priceDeal == undefined) &&
                                                (deal.priceOld == null || deal.priceOld == undefined))">
                    <div class="p-inputgroup">
                        <p-selectButton [options]="couponTypes"
                                        [(ngModel)]="selectedCouponType"
                                        [style]="{'display':'inline-flex'}"
                                        optionLabel="name">
                        </p-selectButton>
                        <span class="p-float-label">
                            <p-inputNumber mode="decimal" locale="{{'LOCALE' | translate}}"
                                           [minFractionDigits]="0"
                                           [maxFractionDigits]="2"
                                           [(ngModel)]="deal.coupon"
                                           pInputText ></p-inputNumber>
                            <label>{{'discount' | translate}}</label>
                        </span>
                    </div>
                </div>
            </div>
            <hr>
            <h4>{{'description' | translate}}</h4>
            <p-editor [(ngModel)]="deal.content" class="w-full" [style]="{'z-index':'0', 'height':'333px'}"></p-editor>
        </ng-template>
        <ng-template pTemplate="footer">
            <div class="grid grid-nogutter justify-content-end">
                <button pButton label="{{'send_deal_btn' | translate}}"
                        type="button"
                        class="p-button-raised p-button-dlnd flex-grow-1 md:flex-grow-0"
                        (click)="submitDeal()"
                        [loading]="isSubmitting">
                </button>
            </div>
        </ng-template>
    </p-card>
    <div class="card" *ngIf="thirdStep">
        <p>{{'shared_deal_confirmation' | translate}}</p>
    </div>
</div>
<p-dialog *ngIf="errorPresent"
          [(visible)]="errorPresent"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{'min-width': '300px'}">
    <p class="m-0">{{serverError.description | translate}}</p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="errorPresent=false" label="{{'ok_btn' | translate}}" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>
